<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>Thêm mới ảnh vào cấu hình hiển thị</strong>
          </div>
          <b-form @submit.prevent="save">
            <b-row>
              <b-col>
                <b-form-group
                  label="Danh mục:"
                  label-for="input-name"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                >
                  <!--<b-form-input type="text" class="col-6" id="input-name" v-model="searchForm.str" placeholder="Nhập tên hoặc mã ..."></b-form-input>-->
                  <treeselect
                    class="col-10 no-padding"
                    id="categoryId"
                    :multiple="true"
                    v-if="categories.length > 0"
                    v-model="configDisplay.categoryIds"
                    placeholder="--- Chọn ---"
                    :options="categories"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Thứ tự hiển thị:"
                  label-align="right"
                  label-for="description"
                  :label-cols="2"
                  :horizontal="true"
                >
                  <b-form-input
                    type="number"
                    class="col-10"
                    v-model="configDisplay.orderDisplay"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group :label-cols="2" :horizontal="true">
                  <b-button
                    v-if="authorize(['ManageConfigDisplay'])"
                    type="submit"
                    variant="primary"
                    >Ghi lại</b-button
                  >
                  <b-button type="button" variant="secondary" @click="cancel">
                    Hủy</b-button
                  >
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { authorizationMixin } from "@/shared/mixins";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
export default {
  name: "CreateConfigDisplay",
  mixins: [validationMixin, authorizationMixin],
  data() {
    return {
      configDisplay: {
        categoryIds: [],
        orderDisplay: null,
      },
    };
  },
  validations: {
    configDisplay: {
      name: { required },
    },
  },
  created() {
    this.loadConfigDisplayDetail();
  },
  computed: {
    ...mapState({
      categories: (state, getters) => getters.categoryTree,
    }),
    sliderId() {
      return this.$route.params.sliderId;
    },
  },
  methods: {
    cancel() {
      this.$router.push({ path: "../" });
    },
    loadConfigDisplayDetail() {
      var vm = this;
      return this.$services
        .get(`system/config-display/${this.sliderId}/config`)
        .done((configDisplay) => {
          vm.configDisplay = configDisplay;
        });
    },
    save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var vm = this;
        this.$services
          .put(`system/config-display/${this.sliderId}`, this.configDisplay)
          .done(() => {
            vm.$toastr.s("Thêm mới cấu hình thành công!");
            vm.cancel();
          });
      }
    },
  },
};
</script>
<style scoped>
</style>
